/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
import React from "react";

import { withGoogleMap, GoogleMap } from "react-google-maps";

const Map = withGoogleMap(props => (
  <GoogleMap defaultZoom={14}  {...props}>
    {props.children}
  </GoogleMap>
));

const MapView = props => {
  return (
    <Map
      containerElement={<div style={{ height: `100%`, width: "100%" }} />}
      mapElement={<div style={{ height: `100%`, width: "100%" }} />}
      defaultCenter={ props.center ?? {
        lat: 11.5496453,
        lng: 104.9065952
      }}
      defaultZoom={props.zoom ?? 13.21}
      {...props}
      // options={{
      //   styles: mapStyle
      // }}
    />
  );
};

export default MapView;
export { MapView };
